import { render, staticRenderFns } from "./editDaHuoV4.vue?vue&type=template&id=44a4eb4d&scoped=true&"
import script from "./editDaHuoV4.vue?vue&type=script&lang=js&"
export * from "./editDaHuoV4.vue?vue&type=script&lang=js&"
import style0 from "./editDaHuoV4.vue?vue&type=style&index=0&id=44a4eb4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a4eb4d",
  null
  
)

export default component.exports